import { api } from "../api";

export const triggerBackup = async () => {
  const response = await api.post("/admin/backup/trigger");
  return response.data;
};

export const listBackups = async () => {
  const response = await api.get("/admin/backup/list");
  return response.data;
};
